/**
 * ConfirmDeletionPage — Redirects to backend confirmation endpoint.
 * The backend returns HTML directly, so this page just handles the redirect.
 */
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import config from 'config';

const API_URL = config.API_URL;

export default function ConfirmDeletionPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const type = params.get('type');
  const [html, setHtml] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setHtml('<p>Lien invalide</p>');
      setLoading(false);
      return;
    }
    // Route to correct backend endpoint based on type
    const endpoint = type === 'client'
      ? `${API_URL}/api/public/confirm-account-deletion?token=${token}`
      : `${API_URL}/api/drivers/confirm-account-deletion?token=${token}`;
    fetch(endpoint)
      .then(res => res.text())
      .then(text => { setHtml(text); setLoading(false); })
      .catch(() => { setHtml('<p>Erreur lors de la confirmation</p>'); setLoading(false); });
  }, [token, type]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#C9A24D]" />
      </div>
    );
  }

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
